import styled from 'styled-components';

export const PublicReportingContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const CustomHeaderContainer = styled.div`
  width: 100%;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: none;
  }
`;

export const PoweredByContainer = styled.div`
  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: none;
  }
`;

export const QuestionHeaderContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  justify-content: center;
  align-items: center;
`;

export const QuestionHeader = styled.h2`
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) => props.theme.newTypography.textStyleBody};
  color: ${(props) => props.theme.newPalette.neutral.N800};
  padding: 30px 0 20px 0;
  width: 100%;
  margin: 0;
`;
